export const isTouchDevice = () => {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
}


export const getScrollOpacities = event => {
  const scroll = window.scrollY;
  const scrollMaximum = window.innerHeight / 2.5;
  let scrollPercentage = 0;
  let leavingOpacity = 100;
  let comingOpacity = 0;
  scrollPercentage = Math.floor((scroll / scrollMaximum) * 100);

  if(scrollPercentage <= 100){
    leavingOpacity = (leavingOpacity - scrollPercentage) / 100;
    comingOpacity = scrollPercentage / 100;
  }else{
    leavingOpacity = 0;
    comingOpacity = 1;
  }

  return {
    comingOpacity,
    leavingOpacity
  };
}
